<form [formGroup]="opCodeForm" class="opcode-service-form">
    <div class="disable-layer" *ngIf="!!disableForm"></div>
    <div class="field-container">
        <div class="action-buttons">
            <button class="cancel-btn" type="button" (click)="cancelForm()">
                <span>{{ 'generalSettings.cancel' | translate }}</span>
            </button>

            <button type="button" class="save-btn" (click)="submitForm()" [disabled]="(isLoading$ | async) || !isValidForm()" [ngClass] = "isValidForm() && !(isLoading$ | async) ? 'enabled' : ''">
                <ng-container *ngIf="isLoading$ | async; else opcodeSaveLabel">
                    <app-loading loadingSymbol="dots" [text]="'testDrive.submitting' | translate" color="white" size=".7" [compact]="true"></app-loading>
                </ng-container>
                <ng-template #opcodeSaveLabel>
                    <span>{{ 'generalSettings.saveChanges' | translate }}</span>
                </ng-template>
            </button>
        </div>
    </div>
    <div class="form-title">{{ 'opcodeServiceManagement.selectedOpcodeDetails' | translate }}</div>
    <div class="opcode-form">
     <div class="opcode-title">
        <div class="title-left" [class.extra-width]="!isAspComplaintCode">
            <div class="opcode-name">{{opCodeForm.get('opcode').value}}
            </div>
        </div>
        <div class="col-dms" *ngIf="isAspComplaintCode">
            <label>{{'opcodeServiceManagement.mapDmsOpcode' | translate}}<span style="color: red;">*</span></label>
            <div *ngIf="!dmsCode.value.isDmsCodeSaved">
        
                <mat-form-field appearance="outline" formGroupName="mapDmsCode">
                    <input type="text" placeholder="Enter DMS Code" #dmsOpcode matInput formControlName="opcodeOption"
                        [matAutocomplete]="auto" (input)="filter(dmsOpcode.value)" (keyup.enter)="mapDmsOpcode()">
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngFor="let option of filteredOptions" [value]="option.opcode" title="{{option.opcode}} | {{option?.displayName ? option?.displayName : option.dmsDescription}}">
                            {{option.opcode}} | {{option?.displayName ? option?.displayName : option.dmsDescription}}
                        </mat-option>
                    </mat-autocomplete>
        
                    <mat-error *ngIf="dmsCode.controls['opcode'].hasError('required')">
                        {{'generalSettings.pleaseEnterValue' | translate}}
                    </mat-error>
        
                    <mat-icon class="add-new-code" (click)="mapDmsOpcode()"
                        (keydown.enter)="mapDmsOpcode()"
                        [ngClass]="!dmsCode.value.opcodeOption ? 'disabled' : ''">add</mat-icon>
                </mat-form-field>
            </div>
        
            <div *ngIf="dmsCode.value.opcode && dmsCode.value.isDmsCodeSaved" class="d-flex">
                <div style="width: 85%">
                    <span>{{dmsCode.value.opcode}}</span>
                </div>
                <div style="width: 15%" class="d-flex">
                    <asp-icon [matTooltip]="'opcodeServiceManagement.editDmsOpcode' | translate" matTooltipClass="asp-custom-tooltip"
                        color='rgba(14,19,25,0.8)' height='0.8rem' name="ic-20-utility-edit.svg" width="0.8rem"
                        style="padding-right: 0.5rem; cursor: pointer;" (click)="onEditDmsOpcode()"></asp-icon>
                    <div class="icons">
                        <asp-icon [matTooltip]="'opcodeServiceManagement.deleteDmsOpcode' | translate" matTooltipClass="asp-custom-tooltip"
                            class='app-icon' height='1rem' width='1rem' name='ic-20-utility-delete-trash.svg'
                            color='rgba(14,19,25,0.8)' style="cursor: pointer" (click)="onDeleteDmsOpcode()">
                        </asp-icon>
                    </div>
                </div>
        
            </div>
        </div>
        <div class="title-right">
            <div class="text" [ngClass]="!isEnglishText ? 'custom-width' : ''">{{ 'opcodeServiceManagement.status' | translate }}</div>
            <div class="switch">
                <app-onofswitch [switchInput]="opCodeForm.get('isVisible').value"
                    (switchChange)="updateSwitchValues($event, 'isVisible')">
                </app-onofswitch>
            </div>
        </div>
    </div>
    <div class="field-container" *ngIf="!isAspComplaintCode">
        <div class="desc-title-container d-inline">{{ 'opcodeServiceManagement.dmsDescription' | translate }} : </div>
        <span>{{opCodeForm.get('dmsDescription').value === '(Not applicable for ASP Service Codes)' ? 
            ('opcodeServiceManagement.notApplicableForAspServiceCodes' | translate) : opCodeForm.get('dmsDescription').value === '(No description available)' ? 
            ('opcodeServiceManagement.noDescriptionAvailable' | translate) : (opCodeForm.get('dmsDescription').value)}}</span>
    </div>
    <div class="field-container">
        <div class="field-left">
            <label class="font-weight-bold">{{ 'opcodeServiceManagement.displayName' | translate }}<span style="color:red">*</span></label>
            <mat-form-field appearance="outline">
                <input matInput formControlName="displayName" placeholder="{{ 'opcodeServiceManagement.enterDisplayName' | translate }}" type="text"
                    autocomplete="off" maxlength="250">
                <mat-error *ngIf="hasError('displayName','required')">{{ 'opcodeServiceManagement.displaynameIsRequired' | translate }}</mat-error>
            </mat-form-field>
        </div>
        <div class="field-center">
            <label class="font-weight-bold">{{ 'opcodeServiceManagement.mileage' | translate }}</label>
            <mat-form-field appearance="outline">
                <mat-select formControlName="mileages" placeholder="{{ 'opcodeServiceManagement.selectMileage' | translate }}">
                    <mat-option [value]="''">{{ 'opcodeServiceManagement.selectMileage' | translate }}</mat-option>
                    <mat-option [value]="mileage" *ngFor="let mileage of (mileages$ | async)">{{mileage}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="field-right" *ngIf="!opCodeForm.get('isInternalCode').value || opcodeTypeField.value!=='maintenance'">
            <label class="font-weight-bold">{{ (isAspComplaintCode ? 'opcodeServiceManagement.complaintCodeType' : 'opcodeServiceManagement.opcodeType') | translate }}</label>
            <mat-form-field appearance="outline">
                <mat-select formControlName="opcodeType" placeholder="{{ 'opcodeServiceManagement.selectType' | translate }}">
                    <mat-option value="other" (click)="removeMileageValidation()">{{ 'opcodeServiceManagement.other' | translate }}</mat-option>
                    <mat-option value="maintenance" (click)="addMileageValidation()">{{ 'opcodeServiceManagement.maintenance' | translate }}</mat-option>
                    <mat-option value="repair" (click)="removeMileageValidation()">{{ 'opcodeServiceManagement.repair' | translate }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="field-container" style="margin-bottom: -1rem">
        <div class="field-left">
            <label class="font-weight-bold">{{ 'opcodeServiceManagement.detailedDescription' | translate }}<span style="color:red">*</span></label>
            <mat-form-field class="no-fixed-height" appearance="outline">
                <textarea matInput formControlName="description" placeholder="{{ 'opcodeServiceManagement.enterDetailedDescription' | translate }}"
                    maxlength="1000"></textarea>
                <mat-error *ngIf="hasError('description','required')">{{ 'opcodeServiceManagement.detailedDescriptionIsRequired' | translate }}</mat-error>
            </mat-form-field>
        </div>
        <div class="field-center column-2">
            <label class="font-weight-bold">{{ 'opcodeServiceManagement.duration(H)' | translate }}<span style="color:red">*</span></label>
            <mat-form-field appearance="outline">
                <input matInput formControlName="labourHours" type="number"
                    placeholder="{{ 'opcodeServiceManagement.enterDuration' | translate }}">
                <mat-error *ngIf="hasError('labourHours','required')">{{ 'opcodeServiceManagement.durationIsRequired' |
                    translate }}</mat-error>
                    <mat-error *ngIf="hasError('labourHours','min')">{{'generalSettings.pleaseEnterValue' |translate }} <strong>{{'generalSettings.greaterThan0' |translate }}</strong></mat-error>
            </mat-form-field>
        </div>
        <div class="column-3" [ngClass]="!isEnglishText ? 'custom-width' : ''">
            <label class="font-weight-bold">{{ 'opcodeServiceManagement.noOfAppointments' | translate }}</label>
                <mat-form-field appearance="outline">
                    <input matInput formControlName="appointmentsAllowed" placeholder="{{ 'opcodeServiceManagement.enterNoOfAppt' | translate }}" type="number"
                        min="0" >
                    <mat-error>{{'generalSettings.pleaseEnterValue' |translate }} <strong>{{'generalSettings.greaterThan0' |translate }}</strong>
                    </mat-error>                
                </mat-form-field>
        </div>
        <div class="field-right mt-4 column-4" [ngClass]="!isEnglishText ? 'custom-width' : ''">
          <mat-checkbox formControlName="commentsEnabled" >
              <span>{{ 'opcodeServiceManagement.userComments' | translate }}</span>
          </mat-checkbox>
          <mat-checkbox formControlName="commentsRequired" [disabled]="!commentsEnabledField.value">
              <span>{{ 'opcodeServiceManagement.commentsRequired' | translate }}</span>
          </mat-checkbox>
        </div>
      </div>
    <app-splitter class="app-splitter mx-3" [config]="'horizontal 100% 0 .7rem'"></app-splitter>

    <div class="field-container">
        <div class="recommendations">
            <div class="option-row">
                <div class="options-1" [ngClass]="isEnglishText ? 'us-label' : 'mx-label'">
                    <div class="text">{{ 'opcodeServiceManagement.recommended' | translate }}</div>
                    <app-onofswitch [switchInput]="opCodeForm.get('recommended.isRecommended').value"
                        (switchChange)="updateSwitchValues($event, 'recommended.isRecommended')">
                    </app-onofswitch>
                </div>
                <div class="options-2" [ngClass]="isEnglishText ? 'en-label' : 'es-label'">
                    <div class="text">{{ 'opcodeServiceManagement.telematics' | translate }}</div>
                    <app-onofswitch [switchInput]="opCodeForm.get('recommended.isTelematics').value"
                        (switchChange)="updateSwitchValues($event, 'recommended.isTelematics')">
                    </app-onofswitch>
                </div>
                <div class="options-3" [ngClass]="isEnglishText ? 'en-label' : 'es-label'">
                    <div [ngClass]="((miscOpcode$ | async).length > 0 && (opCodeForm.get('opcode').value != (miscOpcode$ | async)) ? 'readonly-label' : ' ' + 'text')"
                             [title]="(miscOpcode$ | async).length > 0 && !isMisc.value ?
                             ('opcodeServiceManagement.miscellaneousOpcodeAlreadySetup'|translate) + (miscOpcode$ | async)[0] : ''">
                             {{ 'opcodeServiceManagement.miscellaneous-' | translate }}
                    </div>
                    <div class="options">
                        <app-onofswitch class="switch" [switchInput]="opCodeForm.get('isMiscellaneous').value"
                            (switchChange)="updateSwitchValues($event, 'isMiscellaneous')">
                        </app-onofswitch>
                    <div [ngClass]="(miscOpcode$ | async).length > 0 && (opCodeForm.get('opcode').value != (miscOpcode$ | async)) ? 'readonly-layer' : ''"></div>
                    </div>      
                </div>
            </div>

            <div class="option-row">
                <div class="options-1" [ngClass]="isEnglishText ? 'us-label' : 'mx-label'">
                    <div class="text" *ngIf="isToyotabrand && !isMEXDealer">{{ 'service.coveredByToyotaCare' | translate }}
                    </div>
                    <div class="text" *ngIf="!isToyotabrand">{{ 'service.lexusComplimentaryMaintenance' | translate }}</div>
                    <div class="text" *ngIf="isToyotabrand && isMEXDealer">{{ 'service.toyotaComplimentaryMaintenance'
                        |translate }}</div>
                    <app-onofswitch [switchInput]="opCodeForm.get('recommended.isCoveredByToyotaCare').value"
                        (switchChange)="updateSwitchValues($event, 'recommended.isCoveredByToyotaCare')">
                    </app-onofswitch>
                </div>
                <div class="options-2"  [ngClass]="isEnglishText ? 'en-label' : 'es-label'">
                    <div class="text">{{ 'opcodeServiceManagement.sscRecall' | translate }}</div>
                    <app-onofswitch [switchInput]="opCodeForm.get('recommended.isSSCRecall').value"
                        (switchChange)="updateSwitchValues($event, 'recommended.isSSCRecall')">
                    </app-onofswitch>
                </div>
                <div class="options-3" [ngClass]="isEnglishText ? 'en-label' : 'es-label'">
                    <div class="text" >{{ 'opcodeServiceManagement.complimentaryRentalEligible' | translate }}</div>
                <app-onofswitch class="switch" [switchInput]="opCodeForm.get('isCompRentalEligible').value"
                        (switchChange)="updateSwitchValues($event, 'isCompRentalEligible')">
                </app-onofswitch>
            </div>
            </div>
            <div class="option-row">
            <div *ngIf="toShowTXMfield" class="options-1" [ngClass]="isEnglishText && !isUsDealer ? 'mx-label' : 'us-label'">
                <div class="text" [ngClass]="isEnglishText ? 'en-width' : 'es-width'">{{ 'opcodeServiceManagement.txm' | translate }}</div>
                <app-onofswitch [switchInput]="opCodeForm.get('isTXM').value"
                    (switchChange)="updateSwitchValues($event, 'isTXM')">
                </app-onofswitch>
            </div>
        </div>
        
        </div>
        </div>
    <app-splitter *ngIf="!toShowTXMfield" class="app-splitter mx-3" [config]="'horizontal 100% 0 5.5rem'"></app-splitter>
    <app-splitter *ngIf="toShowTXMfield" class="app-splitter mx-3" [config]="'horizontal 100% 0 8rem'"></app-splitter>
        <div class="field-container d-flex" formGroupName="pricing">
            <div style="width: 28%;">
            <mat-checkbox class="d-inline-flex" formControlName="show" (click)="showPricingValueChange()"><span class="font-weight-bold text-nowrap">{{ 'opcodeServiceManagement.showPricing' | translate }}</span></mat-checkbox>&nbsp;&nbsp;
            <div class="font-weight-bold d-inline-flex text-nowrap" *ngIf="!!opCodeForm.get('pricing.dms').value">
                <span class="pricing-size">(DMS: {{'GLOBAL.CURRENCYSYMBOL' | translate }}{{opCodeForm.get('pricing.dms').value}})</span>
            </div>
        </div>
        <div class="border-box">
            <div class="level-2-field section-border">
                <mat-radio-group style="display: grid;" color="primary" formControlName="pricingType" (click)="pricingTypeChange()">
                    <div class="radio-field-group">
                        <mat-radio-button [value]="pricingType.FIXED">
                            <span class="text-bold">{{ 'opcodeServiceManagement.fixed(Bill+Part+Misc)' | translate }}</span>
    
                        </mat-radio-button>
                        <div class="level-3-field">
                            {{'GLOBAL.CURRENCYSYMBOL' | translate }}
                            <mat-form-field appearance="outline">
                                <input matInput formControlName='fixed' placeholder="{{ 'opcodeServiceManagement.enterFixed(Bill+Part+Misc)' | translate }}"
                                    type="number" autocomplete="off">
                                <mat-error *ngIf="hasError('pricing.fixed','required')">{{ 'opcodeServiceManagement.pleaseEnterFixedPrice' | translate }}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="d-flex">
                    <div class="radio-field-group" style="width: 48%;">
                        <mat-radio-button [value]="pricingType.STARTS_AT"><span class="text-bold">{{ 'opcodeServiceManagement.startingAt' | translate }}</span>
                        </mat-radio-button>
                        <div class="level-3-field">
                            {{'GLOBAL.CURRENCYSYMBOL' | translate }}
                            <mat-form-field appearance="outline">
                                <input matInput formControlName="startsAt" placeholder="{{ 'opcodeServiceManagement.enterStartingat' | translate }}" type="number"
                                    autocomplete="off">
                                <mat-error *ngIf="hasError('pricing.startsAt','required')">{{ 'opcodeServiceManagement.pleaseEnterStartingAtPrice' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
    
                    <div class="radio-field-group">
                        <mat-radio-button [value]="pricingType.RANGE"><span class="text-bold">{{ 'opcodeServiceManagement.priceRange' | translate }}</span>
                        </mat-radio-button>
                        <div class="level-3-field price-range-field" formGroupName="range">
                            {{'GLOBAL.CURRENCYSYMBOL' | translate }}
                            <mat-form-field appearance="outline">
                                <input matInput formControlName="from" placeholder="{{ 'opcodeServiceManagement.from' | translate }}" type="number" autocomplete="off">
                                <mat-error *ngIf="hasError('pricing.range.from','required')">{{ 'opcodeServiceManagement.pleaseEnterFromPrice.' | translate }}
                                </mat-error>
                            </mat-form-field>
    
                            <span>{{ 'opcodeServiceManagement.to ' | translate }}</span>
    
                            {{'GLOBAL.CURRENCYSYMBOL' | translate }}
                            <mat-form-field appearance="outline">
                                <input matInput formControlName="to" placeholder="{{ 'opcodeServiceManagement.to' | translate }}" type="number" autocomplete="off">
                                <mat-error *ngIf="hasError('pricing.range.to','required')">{{ 'opcodeServiceManagement.pleaseEnterToPrice.' | translate }}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
    
                </mat-radio-group>
            </div>
        </div>
        </div>
        <ng-container formGroupName="pricing">
            <div class="field-container d-flex" formGroupName="discount">
                <div [ngStyle]="{'width': isUsDealer ? '24%':'22%'}">
                <mat-checkbox formControlName="isAvailable"><span class="font-weight-bold text-nowrap">{{ 'opcodeServiceManagement.specialService' | translate }}</span></mat-checkbox>
                </div>
                <div class="border-box" style="width: 100%">
            <div class="level-2-field section-border">
                    <div class="field-container">
                        <div class="field-left discount-price">
                            <label class="font-weight-bold">{{ 'opcodeServiceManagement.discountedPrice' | translate }}</label>
                            <div class="dollar-wrap">
                                <span class="dollar">{{'GLOBAL.CURRENCYSYMBOL' | translate }}</span>
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="price" placeholder="{{ 'opcodeServiceManagement.discountedPrice' | translate }}" type="number"
                                        autocomplete="off">
                                    <mat-error *ngIf="hasError('pricing.discount.price','required')">
                                        {{ 'opcodeServiceManagement.discountedPriceIsRequired' | translate }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="field-right expiry-date">
                            <label class="font-weight-bold">{{ 'opcodeServiceManagement.expirationDate' | translate }}</label>
                            <mat-form-field appearance="outline">
                                <input matInput formControlName="validTill" [matDatepicker]="picker" placeholder="{{ 'opcodeServiceManagement.none' | translate }}"
                                    [matDatepickerFilter]="onlyFutureDays" autocomplete="off">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </ng-container>
    <app-splitter class="app-splitter mx-3" [config]="'horizontal 100% 0 29rem'" *ngIf="isAspComplaintCode"></app-splitter>
        <!-- **********Hiding this addOnOpcodes part still finalizing the way to display things in appointment booking flow and Need to store required field 
        values in db itself (instead of calling opcode details while getting all opcode details)********* -->
    <div formGroupName="subComplaints" *ngIf="isAspComplaintCode &&  opcodeTypeField.value!=='maintenance'">
        <mat-checkbox formControlName="checked" (change)="onSubComplaintCodesChecked()">
            <span class="font-weight-bold text-nowrap">{{ 'opcodeServiceManagement.subComplaintCodes' | translate }}</span>
        </mat-checkbox>
    
        <div [ngClass]="issubComplaintCodeEnabled.value ? '' : 'disable-section'">
    
            <div class="field-container" *ngIf="subComplaintCodes?.controls?.length">
    
                <table formArrayName="complaintCodes" aria-describedby="">
                    <thead>
                        <th scope="col" style="width: 30%">{{'opcodeServiceManagement.displayName' | translate}}<span
                                style="color:red">*</span></th>
                        <th scope="col" style="width: 10%">{{ 'servicePersonnel.online' | translate}}</th>
                        <th scope="col" style="width: 11%">{{'opcodeServiceManagement.userComments' | translate}}</th>
                        <th scope="col" style="width: 11%">{{ 'opcodeServiceManagement.commentsRequired' | translate}}</th>
                        <th scope="col" style="width: 30%">{{'opcodeServiceManagement.dmsOpcode' | translate}}</th>
                        <th scope="col" style="width: 8%">{{'servicePersonnel.delete' | translate}}</th>
                    </thead>
                    <tr *ngFor="let item of  subComplaintCodes?.controls, let i = index" [formGroupName]="i">
                        <td>
                            <mat-form-field appearance="outline">
                                <input matInput formControlName="displayName" type="text"
                                    placeholder="{{'opcodeServiceManagement.enterDisplayName' | translate}}">
                                <mat-error>{{ 'opcodeServiceManagement.displaynameIsRequired' | translate}}</mat-error>
                            </mat-form-field>
                        </td>
                        <td>
                            <mat-checkbox #online formControlName="online">
                            </mat-checkbox>
                        </td>
                        <td>
                            <mat-checkbox #userComments formControlName="userComments"
                                (change)="!userComments.checked ? commentsRequired.checked = false : ''"></mat-checkbox>
                        </td>
                        <td>
                            <mat-checkbox #commentsRequired formControlName="commentsRequired"
                                [disabled]="!userComments.checked"></mat-checkbox>
                        </td>
                        <td>
                            <div *ngIf="!item.value.isDmsCodeSaved">
                                <mat-form-field appearance="outline">
                                    <input type="text" (keyup.enter)="mapSubDmsOpcode(i)" placeholder="Enter DMS Code" #dmsOpcodeSub matInput formControlName="dmsCodeOption"
                                        [matAutocomplete]="autoSub" (input)="filterSub(dmsOpcodeSub.value, i)">
                                    <mat-autocomplete #autoSub="matAutocomplete">
                                        <mat-option *ngFor="let option of allDmsOpcodesSubOptions[i]" [value]="option.opcode" title="{{option.opcode}} | {{option?.displayName ? option?.displayName : option.dmsDescription}}">
                                            {{option.opcode}} | {{option?.displayName ? option?.displayName : option.dmsDescription}}
                                        </mat-option>
                                    </mat-autocomplete>
                            
                                    <mat-icon class="add-new-code" (click)="mapSubDmsOpcode(i)" [ngClass]="!item.value.dmsCodeOption ? 'disabled' : ''">add</mat-icon>
                                </mat-form-field>
                            </div>
                            
                            <div *ngIf="item.value.dmsCode && item.value.isDmsCodeSaved" class="sub-dms-code">
                                <div style="padding-right: 10px;">
                                    <span>{{item.value.dmsCode}}</span>
                                </div>
                                <div class="d-flex">
                                    <asp-icon color='rgba(14,19,25,0.8)' height='0.8rem' name="ic-20-utility-edit.svg" width="0.8rem"
                                        style="padding-right: 0.5rem; cursor: pointer;" (click)="onEditSubDmsOpcode(i)"></asp-icon>
                                    <div class="icons">
                                        <asp-icon class='app-icon' height='1rem' width='1rem' name='ic-20-utility-delete-trash.svg'
                                            color='rgba(14,19,25,0.8)' (click)="onDeleteSubDmsOpcode(i)">
                                        </asp-icon>
                                    </div>
                                </div>
                            
                            </div>
                            </td>
    
                        <td>
                            <div style="cursor: pointer" [ngClass]="item.value.isDefault ? 'readonly-layer' : ''">
                                <asp-icon class='app-icon' height='1rem' width='1rem' name='ic-20-utility-delete-trash.svg'
                                    color='rgba(14,19,25,0.8)' (click)="onDeleteChildItem(i)">
                                </asp-icon>
                            </div>
                        </td>
                    </tr>
                </table>
    
            </div>
    
            <div class="addon-sub-item">
                <div class="half-width">
                    <form>
                        <label>{{ 'opcodeServiceManagement.addNewSubComplaintCode' | translate}}<span style="color:red"
                                *ngIf="!subComplaintCodes.value.length">*</span></label>
                        <mat-form-field appearance="outline">
                            <input type="text" autocomplete="off"
                                placeholder="{{ 'opcodeServiceManagement.typeTheSubComplaintCodeYouWishToAdd' | translate}}"
                                matInput [formControl]="addonSubCode">
                        </mat-form-field>
                    </form>
                </div>
    
                <div (click)="onAddSubComplaintCode()" class="d-flex font-weight-bold primary-text-color half-width"
                    style="margin-top: 3rem;" [ngClass]="addonSubCode.value ? '': 'disable-section'">
                    <mat-icon class="add-new">add</mat-icon>
                    <span style="padding-left:2%; cursor: pointer;">{{ 'departmentHolidays.addnew' | translate |
                        titlecase}}</span>
                </div>
            </div>
        </div>
    </div>
</div>
</form>
